import { Box, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./EventsSwiper.css";

import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

const cardSx = {
  textDecoration: "none",
  display: "block",
  bgcolor: "background.default",
  borderRadius: "4px",
  overflow: "hidden",
  boxShadow: "0 8px 0 #ad5d4e",
};

const SmallScreenEvents = (props) => {
  const events = [
    { image: props.update1, link: props.link1, title: props.title1 },
    { image: props.update2, link: props.link2, title: props.title2 },
    { image: props.update3, link: props.link3, title: props.title3 },
  ];

  return (
    <Box sx={{ bgcolor: "primary.main", pt: "12px" }}>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 30,
          stretch: 0,
          depth: 60,
          modifier: 1,
          slideShadows: false,
        }}
        pagination={{ clickable: true }}
        keyboard={{ enabled: true }}
        navigation={true}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="events-swiper"
      >
        {events.map((event, index) => (
          <SwiperSlide key={index}>
            <Box component="a" href={event.link} target="_blank" rel="noopener noreferrer" sx={cardSx}>
              <Box component="img" src={event.image} alt={event.title} sx={{ width: "100%", aspectRatio: "4 / 5", objectFit: "cover", display: "block" }} />
              <Typography variant="h6" sx={{ px: "14px", py: "12px", color: "primary.main" }}>
                {event.title}
              </Typography>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default SmallScreenEvents;
